export default __webpack_public_path__ + "static/media/addButton.f899d42d.svg";